import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import OtpInput from 'react-otp-input';
import { ReactComponent as GmailIcon } from '../assets/img/Gmail_Logo.svg';
import { ReactComponent as OutlookIcon } from '../assets/img/Outlook.svg';
import './OTPVMP.css';

export default function OtpComponent({otp, setOtp, onSubmit, timerValue, emailAccount, resendOtp, title=''}) {
    const { t } = useTranslation();

    const handleKeyDown = (e) => {
        if(e?.key === "Enter" && otp?.length === 6){
            onSubmit();
        }
    }
    
    return (
        <>
            <Typography fontSize={18} fontWeight={700} textAlign={'center'} mb={1.25}>{title ? title : t('auth.verifyEmail.header')}</Typography>
            <div className="body-verify-email-popup">
                <div className="content-verify-email-popup">
                    <div className="otp-verify-email-popup">
                        <OtpInput
                            value={otp}
                            onChange={setOtp}
                            numInputs={6}
                            renderSeparator={<span className="separator-otp-number-popup"></span>}
                            renderInput={(props) => <input {...props} className="input-otp-field-popup" onKeyDown={handleKeyDown}/>}
                            inputType={'number'}
                            shouldAutoFocus={true}
                            
                        />
                        <div className="countdown-verify-email-popup">
                            <AccessTimeIcon sx={{ color: '#44494D', fontSize: '16px' }} />
                            <span style={{paddingLeft: '5px'}}>{timerValue === "00:00" ? t('auth.verifyEmail.timeCountDown') : timerValue}</span>
                        </div>
                    </div>
                </div>
                <div className="title-verify-email-popup">{t('auth.verifyEmail.popup.title')} <span style={{fontWeight: '700'}}>{emailAccount}</span></div>
                <div className="content-verify-email-popup">{t('auth.verifyEmail.receiveEmail')}</div>
                <div className="content-verify-email-popup">
                    <span>{t('auth.verifyEmail.checkEmail')}</span>
                    <span><span className='try-otp' style={{ color: '#ee0033', cursor: 'pointer', marginLeft: '5px', fontWeight: '700'}} onClick={resendOtp} tabIndex={0} onKeyDown={(e) => {if(e.key === "Enter")resendOtp()}}>{t('auth.verifyEmail.try')}</span>.</span>
                </div>
                <div className="content-verify-email-popup">
                    <Button
                        style={{ background: '#CB003D', fontSize: '1em', backgroundColor: '#ee0033' }}
                        size="large"
                        type={'submit'}
                        variant="contained"
                        className="mb-2 mt-3"
                        fullWidth
                        onClick={onSubmit}
                        disabled={otp?.length < 6 ? true : false}
                    >
                        {t('auth.verifyEmail.verify')}
                    </Button>
                </div>
            </div>
            <div className="footer-verify-email-popup">
               
                <div className="content-verify-email-popup" style={{display: 'flex', justifyContent: 'space-between'}}>
                    <Button
                        className="redirect-link-button-popup"
                        variant="outlined"
                        startIcon={<GmailIcon style={{ width: '24px' }} />}
                        onClick={() => window.open('https://mail.google.com/mail', '_blank')}
                    >
                        {t('popup.otp.gmail')}
                    </Button>
                    <Button
                        className="redirect-link-button-popup"
                        variant="outlined"
                        sx={{ marginLeft: '20px' }}
                        startIcon={<OutlookIcon style={{ width: '24px' }} />}
                        onClick={() => window.open('https://outlook.live.com/mail', '_blank')}
                    >
                        {t('popup.otp.outlook')}
                    </Button>
                </div>
            </div>
        </>
    );
}
